import {
  MODAL_CATALOG_LABELS_TITLE,
  MODAL_CATALOG_LABELS_DESCRIPTION,
  BUTTON_GO_BACK,
  BUTTON_SAVE,
} from "../../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../../lib/i18next";
import ModalBasicLayout from "../../../../Modal/ModalBasicLayout";
import { FormProvider, useForm } from "react-hook-form";
import DialogActions from "@mui/material/DialogActions";
import ContainerModalActions from "../../../../Containers/ContainerModalActions";
import CatalogLabelsForm from "./CatalogLabelsForm";

const ModalCatalogLabels = ({
  modalOpen,
  onCloseModal = () => {},
  onCallbackSave = () => {},
  initialValues,
}) => {
  const methods = useForm({
    defaultValues: {
      type: initialValues?.type || "price",
      autoShowEnrollStatus: initialValues?.autoShowEnrollStatus ?? false,
      layerType: initialValues?.layerType || "textOverlay",
      opacity: initialValues?.opacity || 100,
      overlayPosition: initialValues?.overlayPosition || "topLeft",
      overlayShape: initialValues?.overlayShape || "rectangle",
      shapeColor: initialValues?.shapeColor || "auto",
      textColor: initialValues?.textColor || "auto",
      textFont: initialValues?.textFont || "openSans",
    },
  });
  const { t } = useTranslationApp();

  const onSubmit = async () => {
    const isValid = await methods?.trigger();

    if (!isValid) return;

    const data = methods.getValues();
    onCallbackSave(data);
    onCloseModal();
  };

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      maxWidth="sm"
      scroll="paper"
      title={t(MODAL_CATALOG_LABELS_TITLE)}
      description={t(MODAL_CATALOG_LABELS_DESCRIPTION)}
    >
      <FormProvider {...methods}>
        <CatalogLabelsForm />
      </FormProvider>
      <DialogActions
        sx={{
          p: 0,
        }}
      >
        <ContainerModalActions
          propsSecondaryButton={{
            showButton: true,
            text: BUTTON_GO_BACK,
            onClick: onCloseModal,
          }}
          propsPrimaryButton={{
            showButton: true,
            text: BUTTON_SAVE,
            onClick: onSubmit,
          }}
        />
      </DialogActions>
    </ModalBasicLayout>
  );
};

export default ModalCatalogLabels;
